<template>
  <div class="background" id="parallax">
    <div class="background__layer" data-depth="0.04">
      <div class="background__nebula"></div>
    </div>
    <div class="background__layer" data-depth="0.1">
      <div class="background__pluses"></div>
    </div>
    <div class="background__layer" data-depth="0.07">
      <div class="background__planet planet-purple"></div>
    </div>
    <div class="background__layer" data-depth="0.13">
      <div class="background__planet planet-green"></div>
    </div>
    <div class="background__layer" data-depth="0.13">
      <div class="background__astronauts"></div>
    </div>
  </div>
</template>

<script>
  import Parallax from 'parallax-js'

  export default {
    mounted() {
      var scene = document.getElementById('parallax');
      if (scene) {
        var parallaxInstance = new Parallax(scene);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/styles/utils.sass';

  .background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    overflow: hidden;
    left: 0;
  }

  .background__layer {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .background__nebula {
    width: 120%;
    height: 120%;
    position: absolute;
    top: -5%;
    left: -5%;
    background-size: cover;
    background-position: center;
    @include image('nebula.png');
  }

  .background__pluses {
    width: 120%;
    height: 120%;
    position: absolute;
    top: -5%;
    left: -5%;
    background-size: cover;
    background-position: top left;
    @include image('pluses.svg');
    opacity: 0.04;
  }


  .background__planet {
    position: absolute;
    width: 170px;
    height: 170px;
    background-size: cover;

    &.planet-green {
      left: -50px;
      top: 190px;
      @include image('planet--green.png');
    }

    &.planet-purple {
      right: -10px;
      top: 180px;
      @include image('planet--purple.png');
    }
  }

  .background__astronauts {
    width: 756px;
    height: 287px;
    @include image('hero-astronauts.svg');
    position: absolute;
    bottom: -20px;
    left: 50%;
    margin-left: -378px;
  }
</style>